exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".surveyContainer, .surveyIFrame {\n  border: none;\n  z-index: 10;\n}\n\n.surveyIFrame {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Display/Components/Surveys/NielsenSurvey.css
// module id = 194
// module chunks = 6